import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Servidor } from '../../../../types/Servidor.type';

@Injectable({
  providedIn: 'root'
})
export class ServidoresService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAll(){
    return this.httpClient.get<Servidor[]>(`${this.configService.getApiUrl()}/servidor`);
  }

  post(servidor: Servidor){
    return this.httpClient.post<Servidor>(`${this.configService.getApiUrl()}/servidor`, servidor);
  }

  delete(id: string){
    return this.httpClient.delete(`${this.configService.getApiUrl()}/servidor/` + id);
  }

  put(servidor: Servidor){
    return this.httpClient.put(`${this.configService.getApiUrl()}/servidor`, servidor);
  }
}
